export const calendarConstants = {
  SHORTHAND_URL_SUCCESS: "SHORTHAND_URL_SUCCESS",
  SHORTHAND_URL_FAILURE: "SHORTHAND_URL_FAILURE",
  SHORTHAND_URL_LOADING: "SHORTHAND_URL_LOADING",

  SAVE_FROM_CALENDAR_DATE: "SAVE_FROM_CALENDAR_DATE",
};
